import axiosClient, { HOST } from './axiosClient';

const rolePermissionService = {
  getListPermission: () =>
    axiosClient
      .get(`${HOST.USER_SERVICE}/user-meta-data/permissions`)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error)),
  searchListPermission: (name) =>
    axiosClient
      .get(`${HOST.USER_SERVICE}/user-meta-data/permissions?name=${name}`)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error)),
  getListPermissions: () =>
    axiosClient
      .get(`${HOST.USER_SERVICE}/user-meta-data/permissions`)
      .then((response) => Promise.resolve(response.data.permissionGroupDtos))
      .catch((error) => Promise.reject(error)),
  getListRoles: () => axiosClient.get(`${HOST.USER_SERVICE}/admin-users/roles`),
  createRole: (payload) =>
    axiosClient
      .post(`${HOST.USER_SERVICE}/admin-users/roles`, payload)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error)),
  editRole: (id, payload) =>
    axiosClient
      .put(`${HOST.USER_SERVICE}/admin-users/roles/${id}`, payload)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error)),
  getRolebyID: (id) =>
    axiosClient
      .get(`${HOST.USER_SERVICE}/admin-users/roles/${id}`)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error)),
};

export default rolePermissionService;
